module.exports = __webpack_public_path__ + "static/img/logo-ctzn.f9e12590.jpg";